import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-pin",
  "use": "icon-pin-usage",
  "viewBox": "0 0 18 23",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 23\" id=\"icon-pin\"><path d=\"M15.805 8.62a7.184 7.184 0 0 0-14.368 0c0 3.004 5.99 12.22 7.184 12.213 1.176.007 7.184-9.25 7.184-12.212zm1.437 0c0 3.557-7.21 14.375-8.621 14.368C7.188 22.995 0 12.225 0 8.621a8.621 8.621 0 0 1 17.242 0zm-6.466 0a2.155 2.155 0 1 0-4.31 0 2.155 2.155 0 0 0 4.31 0zm1.437 0a3.592 3.592 0 1 1-7.185 0 3.592 3.592 0 0 1 7.185 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol